export const generateMockInitData = (): string => {
	const isAdmin = true

	const mockUser = {
		id: isAdmin ? 1981289992 : 123456789,
		first_name: isAdmin ? "Aidamir" : "Dev",
		last_name: isAdmin ? "Kambiev" : "User",
		username: isAdmin ? "aidamirrrrrr" : "devuser",
		language_code: "ru",
		is_premium: isAdmin,
		allows_write_to_pm: true,
	}

	const authDate = Math.floor(Date.now() / 1000)

	const params = new URLSearchParams({
		user: JSON.stringify(mockUser),
		auth_date: authDate.toString(),
		hash: "mock_hash_for_development",
	})

	return params.toString()
}
